export type UserType = 'regular' | 'free';

export const REGULAR: UserType = 'regular';
export const FREE: UserType = 'free';
